import { createContext, useContext } from 'react';

/**
 * Signals whether the surrounding keep-alive tab is the one currently on screen.
 *
 * Why this exists: a position:fixed floating pill (bulk-action bar) is portaled
 * OUT of its tab's `KeepAliveTab` wrapper to escape the tab-switch reveal
 * transform (see BulkActionBarShell). But the wrapper is what used to hide the
 * pill for free via `display:none` when the tab wasn't active. Once portaled, the
 * pill lives outside that wrapper, so on a kept-alive (still-mounted) tab with a
 * live selection it would bleed onto whatever tab IS showing. Consumers read this
 * to suppress the portaled pill when their tab isn't the active one.
 *
 * Default `true` so components rendered outside any KeepAliveTab (desktop,
 * standalone, tests) behave normally.
 */
const KeepAliveTabVisibilityContext = createContext(true);

export function useKeepAliveTabVisible() {
  return useContext(KeepAliveTabVisibilityContext);
}

export default KeepAliveTabVisibilityContext;
